"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const BoxPlotEvolution_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/models/evolution/BoxPlotEvolution"));
const Cluster_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Cluster"));
const Parcel_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Parcel"));
const lodash_1 = __importDefault(require("lodash"));
let TestBoxPlotEvolutionAPIVue = class TestBoxPlotEvolutionAPIVue extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.bpe = new BoxPlotEvolution_1.default();
    }
    mounted() {
        this.init();
    }
    async init() {
        const parcels = await Parcel_1.default.all();
        const samples = [];
        parcels.forEach(p => p.samples.forEach(s => { samples.push(s); }));
        const [samplesA, samplesB] = lodash_1.default.chunk(samples, 2);
        const clusterA = new Cluster_1.default(0);
        clusterA.name = 'Cluster A';
        samplesA.forEach(s => clusterA.add(s));
        const clusterB = new Cluster_1.default(1);
        clusterB.name = 'Cluster B';
        samplesB.forEach(s => clusterB.add(s));
        this.bpe.setClusters(clusterA, clusterB);
    }
    async load() {
        await this.bpe.load();
    }
};
TestBoxPlotEvolutionAPIVue = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {}
    })
], TestBoxPlotEvolutionAPIVue);
exports.default = TestBoxPlotEvolutionAPIVue;
